module.exports = __webpack_public_path__ + "static/media/dashboard1.ab6703b2.png";